import { ImageSkeleton } from '@/components/atoms/Skeleton';
import Image from 'next/image';
import classnames from 'classnames';

export type SponsorCard = {
  className?: string;
  vendorId: string;
  vendorSlug: string;
  fundCompanyNameLocal: string;
  fundCompanyName: string;
  title: string;
  content: string;
  activityUrl: string;
  openAccountUrl: string;
  openAccountCta: string;
  purchaseUrl: string;
  purchaseCta: string;
  tags: string;
  enable: number;
  applyToPurchase: number;
  applyToChannel: number;
  updatedAt: string;
  logo: { src: string };
};

/**
 * applyToChannel: 1: 要在外匯看盤室顯示, 0: 不要在外匯看盤室顯示
 * @returns
 */
const Card = ({
  className,
  title,
  content,
  enable,
  logo,
  applyToChannel,
  activityUrl,
  openAccountUrl /* 開戶連結 */,
  openAccountCta /* 開戶按鈕 */,
  purchaseCta /* 申購按鈕 */,
  purchaseUrl /* 申購連結 */
}: SponsorCard) => {
  if (!enable || !applyToChannel) return null;
  const src = logo?.src;

  return (
    <li
      className={classnames(
        'w-[calc(50%-4px)] list-none rounded-lg border bg-white p-4 px-0 pb-5 text-center shadow-[0_0_6px_0_#00418f1a] md:w-[172px] lg:block lg:w-[218px] lg:pb-6',
        className
      )}
    >
      <a
        href={activityUrl}
        target='_blank'
        rel='noopener noreferrer'
        className='relative mx-3 block h-[56px] lg:mx-auto lg:mb-3 lg:h-[70px] lg:w-[162px]'
      >
        {src ? <Image alt='sponsor-logo' src={src} fill sizes='100%' className='object-contain' /> : <ImageSkeleton />}
      </a>
      <h3 className='mb-4 mt-3 px-0 font-semibold leading-[22px] text-[#1c1e2f] lg:mb-3 lg:mt-[18px] lg:text-lg lg:leading-[18px]'>
        {title}
      </h3>
      <div className='px-3'>
        <p
          className='mb-4 line-clamp-2 min-h-11 text-xs leading-[22px] text-[#777777] lg:mb-6 lg:text-sm/[22px]'
          dangerouslySetInnerHTML={{ __html: content }}
        />
        <div className='flex items-center gap-2'>
          <a
            className='block w-full rounded-lg bg-gradient-to-l from-[#dd3710] to-[#fc6f3d] leading-[30px] text-white hover:to-[#dd3710]'
            href={openAccountUrl}
            target='_blank'
          >
            {openAccountCta}
          </a>
          {Boolean(purchaseCta) && (
            <a
              className='block w-full rounded-lg border border-[#dd3710] leading-[30px] text-[#dd3710] hover:font-medium'
              href={purchaseUrl}
              target='_blank'
            >
              {purchaseCta}
            </a>
          )}
        </div>
      </div>
    </li>
  );
};

export default Card;
